import logo from '../assets/logo-orange.png';
import './PageLoader.css';

export default function PageLoader({ label = 'Φόρτωση…', fullPage = false }) {
  return (
    <div className={`page-loader${fullPage ? ' page-loader--full' : ''}`} role="status" aria-live="polite">
      {fullPage && <img src={logo} alt="G-Unit Fitness" width="1322" height="752" className="page-loader__logo" />}
      <span className="page-loader__spinner" aria-hidden="true" />
      <span className="page-loader__label">{label}</span>
    </div>
  );
}
